var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isToday || _vm.isYesterday)?_c('span',[(_vm.isToday)?_c('v-chip',{attrs:{"label":"","small":"","color":"primary"}},[_vm._v(" Hoje ")]):_vm._e(),(_vm.isYesterday)?_c('v-chip',{attrs:{"label":"","small":"","color":"secondary"}},[_vm._v(" Ontem ")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }